import { Component, Input, OnInit } from '@angular/core';
import { OptionView } from 'src/app/models/products/products';
import { DynamicOptionResponse } from 'src/app/models/products/transactions';
import { ProductDetailsUiStateService } from '../../product-details-ui-state.service';

@Component({
  selector: 'app-dynamic-options-pricelist',
  templateUrl: './dynamic-options-pricelist.component.html',
  styleUrls: ['./dynamic-options-pricelist.component.scss']
})
export class DynamicOptionsPricelistComponent implements OnInit {
  @Input() currentOptionIndex: number;
  @Input() ProductOptionItems: Array<OptionView>;

  constructor(private _pUiService: ProductDetailsUiStateService,) { }

  ngOnInit(): void {
  }

  isDynamicOptionsChosen(dynamicOptionItem: DynamicOptionResponse, prodIndex: number): boolean{
    return this._pUiService.clientTransactionViewForm.get(['DynamicOptionResponses', prodIndex])?.value?.Value === dynamicOptionItem.Label;
  }

}
